module.exports = __webpack_public_path__ + "static/media/qrcode-scan.56b6e2e1.gif";